import { Button, Hidden, Slide, useScrollTrigger } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import SentimentSatisfiedAltIcon from "@material-ui/icons/SentimentSatisfiedAlt";
import axios from "axios";
import Geohash from "latlon-geohash";
import React, { ReactElement, useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Route, Switch, useLocation } from "wouter";
// @ts-ignore
import zipcodeJa from "zipcode-ja";
import firebase from "./firebase";
import ListAll from "./ListAll";
import ListMine from "./ListMine";
import ListNearby from "./ListNearby";
import Login from "./Login";
import { CurrentPosition } from "./types";
import Upload from "./Upload";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    display: "block",
  },
  bottomNav: {
    position: "fixed",
    bottom: 0,
    zIndex: 1000,
    width: "100%",
  },
}));

function HideOnScroll(props: { children: ReactElement }) {
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {props.children}
    </Slide>
  );
}

function App() {
  const [position, setPosition] = useState<CurrentPosition>({
    latitude: 0,
    longitude: 0,
    name: "位置情報不明",
    geohash: "",
  });
  const [, setLocation] = useLocation();
  const classes = useStyles();
  const [user] = useAuthState(firebase.auth());

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        const geohash = Geohash.encode(latitude, longitude);
        axios
          .get(
            `https://mreversegeocoder.gsi.go.jp/reverse-geocoder/LonLatToAddress?lat=${latitude}&lon=${longitude}`
          )
          .then(function (response) {
            const pos: any = Object.values(zipcodeJa).find(
              (x: any) => x.jisX0402 === response.data.results.muniCd
            );
            const name = pos.address.join("");
            setPosition({ latitude, longitude, name, geohash });
          })
          .catch(function (e) {
            setPosition({ latitude, longitude, name: "位置情報不明", geohash });
          });
      });
    }
  }, []);

  return (
    <div className="App">
      <CssBaseline />
      <HideOnScroll>
        <AppBar>
          <Toolbar>
            <img
              alt="みんなのテイクアウト"
              style={{ height: "25px", width: "auto", marginRight: "5px" }}
              src="/fork.svg"
            />
            <Typography
              className={classes.title}
              variant="h6"
              noWrap
              onClick={() => {
                setLocation("/");
              }}
            >
              みんなのテイクアウト
            </Typography>

            {user && (
              <Button
                onClick={() => {
                  firebase.auth().signOut();
                }}
              >
                ログアウト
              </Button>
            )}
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar></Toolbar>
      <Switch>
        <Route path="/">
          <ListNearby {...position} />
        </Route>
        <Route path="/mines">
          <ListMine {...position} />
          <div style={{ marginBottom: "100px" }}></div>
        </Route>
        <Route path="/upload" key="/upload">
          <Upload></Upload>
          <div style={{ marginBottom: "100px" }}></div>
        </Route>
        <Route path="/upload/:id" key="/upload/:id">
          <Upload></Upload>
          <div style={{ marginBottom: "100px" }}></div>
        </Route>
        <Route path="/all">
          <ListAll {...position} />
        </Route>
        <Route path="/login">
          <Login></Login>
          <div style={{ marginBottom: "100px" }}></div>
        </Route>
      </Switch>
      <BottomNavigation showLabels className={classes.bottomNav}>
        <BottomNavigationAction
          label="近くのお店"
          icon={<LocationOnIcon />}
          onClick={() => {
            setLocation("/");
          }}
        />
        <BottomNavigationAction
          label="投稿"
          icon={<PhotoCamera />}
          onClick={() => {
            setLocation("/upload");
          }}
        />
        <BottomNavigationAction
          label="自分の投稿"
          icon={<SentimentSatisfiedAltIcon />}
          onClick={() => {
            setLocation("/mines");
          }}
        />
        <Hidden smUp>
          <BottomNavigationAction />
        </Hidden>
      </BottomNavigation>
    </div>
  );
}

export default App;
